import { gql } from '@apollo/client';

import { interactiveLessonSectionComponentFragment } from '../lesson-builder.graphql';

export const ADD_NEW_IMAGE_TO_EXISTING_COMPONENT = gql`
  mutation AddNewImageToExistingComponent(
    $input: AddNewImageToComponentInput!
  ) {
    addNewImageToExistingComponent(input: $input) {
      ...InteractiveLessonSectionComponent
    }
  }
  ${interactiveLessonSectionComponentFragment}
`;

export const ADD_NEW_IMAGE_AND_NEW_COMPONENT = gql`
  mutation AddNewImageAndNewComponent($input: AddNewImagAndNewComponentInput!) {
    addNewImageAndNewComponent(input: $input) {
      ...InteractiveLessonSectionComponent
    }
  }
  ${interactiveLessonSectionComponentFragment}
`;

export const ADD_RIVE_FILE_TO_COMPONENT = gql`
  mutation AddRiveFileToComponent($input: AddRiveFileToComponentInput!) {
    addRiveFileToComponent(input: $input) {
      ...InteractiveLessonSectionComponent
    }
  }
  ${interactiveLessonSectionComponentFragment}
`;

export const ADD_GIF_FILE_TO_COMPONENT = gql`
  mutation AddGifFileToComponent($input: AddGifFileToComponentInput!) {
    addGifFileToComponent(input: $input) {
      ...InteractiveLessonSectionComponent
    }
  }
  ${interactiveLessonSectionComponentFragment}
`;
